import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const ProductDetail = () => {
  const { idx } = useParams(); // Product의 고유 ID
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(
          `https://www.medicode.co.kr:8445/api/get/product/${idx}`
        );
        setProduct(response.data);
      } catch (error) {
        console.error("Error fetching product data:", error);
      }
    };

    fetchProduct();
  }, [idx]);

  if (!product) {
    return <div>Loading...</div>;
  }

  const handleDownload = async (img) => {
    try {
      const response = await axios.get(
        `https://www.medicode.co.kr:8445/uploads/${img}`,
        {
          responseType: "blob", // 응답을 Blob으로 설정
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", img); // 다운로드할 파일 이름 설정
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url); // 메모리 해제
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  return (
    <div className="board-detail-wrap">
      <h2>{product.title}</h2>
      <p className="detail-txt-intro">
        작성자 <span>{product.writer}</span> &nbsp;&nbsp;&nbsp;작성일{" "}
        <span>{new Date(product.date).toISOString().split("T")[0]}</span>
        &nbsp;&nbsp;&nbsp;조회수: <span>{product.hit}</span>
      </p>
      <div className="detail-img-wrap">
        <img
          src={`https://www.medicode.co.kr:8445/uploads/${product.img1}`}
          alt={product.title}
        />
      </div>
      <div className="product-price-wrap">
        {(() => {
          switch (product.title) {
            case "스마트 플러스":
              return "✅ 스마트 30만원상당";
            case "VIP 패키지":
              return "✅ VIP 120만원상당";
            case "노블레스 패키지":
              return "✅ 노블레스 300만원상당";
            case "프리미엄 패키지":
              return "✅ 프리미엄 90만원상당";
            case "프레스티지":
              return "✅ 프레스티지 170만원 상당";
            case "VIP 1+1":
              return "✅ VIP 1+1 240만원상당";
            case "프리미엄검진+스킨케어":
              return "✅ 프리미엄+스킨케어 370만원 상당";
            default:
              return "가격 정보 없음";
          }
        })()}
      </div>
      <div className="detail-main-txt">
        <p dangerouslySetInnerHTML={{ __html: product.content }} />
      </div>
      <div className="detail-attachment-wrap">
        <p></p>
        {/* {['img1', 'img2', 'img3', 'img4', 'img5'].map((imgKey) => {
          const imgValue = product[imgKey];
          return imgValue ? (
            <button key={imgKey} onClick={() => handleDownload(imgValue)}>
              {imgValue} 다운로드
            </button>
          ) : null;
        })} */}
      </div>
      <div className="detail-list-btn">
        <button onClick={() => navigate(`/board/product`)}>목록</button>
      </div>
    </div>
  );
};

export default ProductDetail;
